<template>
  <div>
    <p>Препарат: <strong>{{ drug.title }}</strong></p>
    <p>Накладная <strong>{{ invoice.id }}</strong>
      <button @click="showInvoice(invoice.id)" class="btn btn-xs btn-info newWindowBtn">
        <i class="icon-fa icon-fa-eye"></i>
      </button>
    </p>
    <div class="pt-2">
      <p>В накладной количество: <strong>{{ taskData.invoice_qty }}</strong></p>
      <p>На складе отправителя: <strong>{{ taskData.store_remain }}</strong></p>
    </div>
  </div>
</template>

<script>

export default {
  props: ['drug', 'invoice', 'taskData'],
  data() {
    return {}
  },
  methods: {
    showInvoice(id) {
      this.$store.dispatch('platform/setGlobalDrawerData', {
        data: {type: 'editInvoice', invoiceId: id},
        // callBackAction: (p) => this.updatePhoneRecord(phone.id, p)
      });
    },
  }
}

</script>
